export const TRANSLATIONS_APPID = {
    BATS: 2
}